export const isDemo =
  (window.REACT_APP_EVOBUS_DEMO || process.env.REACT_APP_EVOBUS_DEMO) === 'true'

export const isDemoError = (error) => error?.response?.status === 409
